import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../common/GetProxy";
import { handleResponseCode } from "../../../app/utilities/helpers";

const proxy = GetProxy();
const cookies = new Cookies();

// ===================== THUNKS =====================

export const getPMOApprovalList = createAsyncThunk(
  "post/getPMOApprovalList",
  async (props, { rejectWithValue }) => {
    try {
      const { pageNumber, itemsPerPage, keyword, fyYear, isPMO } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      // PMO uses approval list endpoint; other roles use overview table endpoint
      const url = isPMO
        ? `${proxy}/api/v1/supplierContractApproval/list/${pageNumber}/${itemsPerPage}`
        : `${proxy}/api/v1/supplierContract/overViewTableList/${pageNumber}/${itemsPerPage}`;
      const response = await fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify({ keyword, fyYear, ...(!isPMO && { submitType: "ACTIVE" }) }),
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.log("Error in getting PMO Approval List : ", error);
      throw error;
    }
  },
);

export const updateApprovalStatus = createAsyncThunk(
  "post/updateApprovalStatus",
  async (props, { rejectWithValue }) => {
    try {
      const { id, status, description, requestBy } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/supplierContractApproval/updateStatus`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify({ id, status, description: description, requestBy }),
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.log("Error in updating Approval Status : ", error);
      throw error;
    }
  },
);

export const getApprovalInfo = createAsyncThunk(
  "get/getApprovalInfo",
  async (props, { rejectWithValue }) => {
    try {
      const { contractId } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/supplierContractApproval/info/${contractId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.log("Error in getting Approval Info : ", error);
      throw error;
    }
  },
);

// ===================== INITIAL STATE =====================

const initialState = {
  approvalList: [],
  approvalListLoading: false,
  approvalListTotalCount: 0,
  error: "",
  apierror: false,
};

// ===================== SLICE =====================

export const PMOApprovalSlice = createSlice({
  name: "pmoApprovalSlice",
  initialState,
  reducers: {
    resetPMOApprovalData: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPMOApprovalList.pending, (state, action) => {
        state.approvalListLoading = true;
        state.approvalList = [];
        state.approvalListTotalCount = 0;
        state.error = "";
        state.apierror = false;
      })
      .addCase(getPMOApprovalList.fulfilled, (state, action) => {
        state.approvalListLoading = false;
        state.approvalList = action.payload?.data || [];
        state.approvalListTotalCount = action.payload?.totalCount || 0;
        state.apierror = false;
      })
      .addCase(getPMOApprovalList.rejected, (state, action) => {
        state.approvalListLoading = false;
        state.approvalList = [];
        state.approvalListTotalCount = 0;
        state.error = "something went wrong";
        state.apierror = true;
      });
  },
});

export const { resetPMOApprovalData } = PMOApprovalSlice.actions;
export default PMOApprovalSlice.reducer;
